import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux'
import HeaderTablePage from '../components/HeaderTablePage';
import { Link } from 'react-router-dom';
import InstitutionSelector from 'components/configs/social-media/InstitutionSelector';
import { verifyTokenExpire } from 'middleware/verifyToken';
import appConfig from 'config/appConfig';
import { verifyPermission } from 'helpers/permission';
import axios from 'axios';
import FacebookConfigAddForm from 'views/components/SocialMediaConfig/FacebookConfigAddForm';
import WhatsappConfigAddForm from 'views/components/SocialMediaConfig/WhatsappConfigAddForm';
import LinkedinConfigAddForm from 'views/components/SocialMediaConfig/LinkedinConfigAddForm';
import { ToastBottomEnd } from 'views/components/Toast';
import { toastErrorMessageWithParameterConfig, toastSuccessMessageWithParameterConfig } from 'config/toastConfig';
import { set } from 'react-hook-form';

const endPointConfig = {
  PRO: {
    plan: "PRO",
    list: `${appConfig.apiDomaine}/my/processing-circuits`,
  },
  MACRO: {
    holding: {
      list: `${appConfig.apiDomaine}/any/processing-circuits`,
    },
    filial: {
      list: `${appConfig.apiDomaine}/my/processing-circuits`,
    },
  },
  HUB: {
    plan: "HUB",
    list: `${appConfig.apiDomaine}/without-institution/processing-circuits`,
  },
};

const SocialMediaConfigAddForm = (props) => {
    //usage of useTranslation i18n
    const { t, ready } = useTranslation();

    const defaultError = {
        institution_id: [],
        fields: [],
        fields2: [],
        fields3: [],
        facebookError: "",
        whatsappError: "",
        linkedinError: "",
    };

    const defaultData = {
        institution_id: "",
        linkedin_configs: {},
        facebook_configs: {},
        whatsapp_configs: {},
    };

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(defaultError);
    const [institutionData, setInstitutionData] = useState(undefined);
    const [institution, setInstitution] = useState(null);
    const [data, setData] = useState(defaultData);
    const [fields, setFields] = useState([]);
    const [fields2, setFields2] = useState([]);
    const [fields3, setFields3] = useState([]);

    const getEndpoint = useCallback(() => {
        let endPoint = "";
        if (props.plan === "MACRO") {
            if (
                verifyPermission(
                    props.userPermissions,
                    "update-processing-circuit-any-institution"
                )
            ) {
                endPoint = endPointConfig[props.plan].holding;
            } else if (
                verifyPermission(
                    props.userPermissions,
                    "update-processing-circuit-my-institution"
                )
            ) {
                endPoint = endPointConfig[props.plan].filial;
            }
        } else {
            endPoint = endPointConfig[props.plan];
        }
        return endPoint;
    }, [props.plan, props.userPermissions]);

    const addField = () => {
        const newField = { key: null, value: null };
        setFields([...fields, newField]);
        setError({ ...error, fields: { ...error.fields, [fields.length]: {key: null, value: null} } });
    };

    const addField2 = () => {
        const newField = { key: null, value: null };
        setFields2([...fields2, newField]);
        setError({ ...error, fields2: { ...error.fields2, [fields2.length]: {key: null, value: null} } });
    };

    const addField3 = () => {
        const newField = { key: null, value: null };
        setFields3([...fields3, newField]);
        setError({ ...error, fields3: { ...error.fields3, [fields3.length]: {key: null, value: null} } });
    };

    const removeField = (index) => {
        setFields(fields.filter((field, i) => i !== index));
        setError({ ...error, fields: Object.fromEntries(Object.entries(error.fields).filter(([key]) => key !== index.toString())) });
    };

    const removeField2 = (index) => {
        setFields2(fields2.filter((field, i) => i !== index));
        setError({ ...error, fields2: Object.fromEntries(Object.entries(error.fields2).filter(([key]) => key !== index.toString())) });
    };

    const removeField3 = (index) => {
        setFields3(fields3.filter((field, i) => i !== index));
        setError({ ...error, fields3: Object.fromEntries(Object.entries(error.fields3).filter(([key]) => key !== index.toString())) });
    };

    const onChangeInstitution = (selected) => {
        const institution_id = selected;
        setInstitution(institution_id);
    };

    // END POINT
    const postSocialMediaEndpoint = `${appConfig.apiDomaine}/social-network/configs`;

    const addSocialMediaConfig = async() => {
        axios
        .post(postSocialMediaEndpoint, data)
        .then((response) => {
            ToastBottomEnd.fire(toastSuccessMessageWithParameterConfig("Configuration ajouter avec succès"));
            window.location.reload();
            setLoading(false);
        })
        .catch((error) => {
            ToastBottomEnd.fire(toastErrorMessageWithParameterConfig("Erreur lors de l'ajout de la configuration"));
            setLoading(false);
        });
    };

    const onSubmit = async(e) => {
        e.preventDefault();
        setLoading(true);
        
        let hasError = false;
        let hasError2 = false;
        let hasError3 = false;

        fields.forEach((field) => {
            if (!field.key || !field.value) {
                hasError = true;
            }
        });

        fields2.forEach((field) => {
            if (!field.key || !field.value) {
                hasError2 = true;
            }
        });

        fields3.forEach((field) => {
            if (!field.key || !field.value) {
                hasError3 = true;
            }
        });

        if (hasError || hasError2 || hasError3) {
            if(hasError) setError({...error, facebookError: 'Veuillez renseigner toutes les clés pour la configuration Facebook' });
            if(hasError2) setError({...error, whatsappError: 'Veuillez renseigner toutes les valeurs pour la configuration Facebook' });
            if(hasError3) setError({...error, linkedinError: 'Veuillez renseigner toutes les clés et valeurs ajouter' });
            
            ToastBottomEnd.fire(toastErrorMessageWithParameterConfig("Veuillez renseigner toutes les clés et valeurs ajouter"));
            setLoading(false);
            return;
        } else {

            let facebookData = {};
            let whatsappData = {};
            let linkedinData = {};

            fields.forEach((field) => {
                facebookData[field.key] = field.value;
            });

            fields2.forEach((field) => {
                whatsappData[field.key] = field.value;
            });

            fields3.forEach((field) => {
                linkedinData[field.key] = field.value;
            });

            setError({...error, facebookError: '', whatsappError: '', linkedinError: ''});
            setData({ ...data, institution_id: institution.value, facebook_configs: facebookData, whatsapp_configs: whatsappData, linkedin_configs: linkedinData });
        }
    };

    useEffect(() => {
        if (data && data!==defaultData) {
            addSocialMediaConfig();
        }
    }, [data]);

    useEffect(() => {
        const fetchData = async () => {
            if (!verifyTokenExpire()) return;

            const endPoint = getEndpoint();

            try {
                setLoading(true);

                {/*if (
                verifyPermission(
                    userPermissions,
                    "update-processing-circuit-any-institution"
                )
                ) {*/
                const institutionResponse = await axios.get(endPoint.list);
                const options = institutionResponse.data.institutions.length
                    ? institutionResponse.data.institutions.map((institution) => ({
                        value: institution.id,
                        label: institution.name,
                    }))
                    : [];
                    setInstitutionData([options]);
                }

                const response = await axios.get(endPoint.list);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return (
        <div 
            className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
            id="kt_content"
        >

            <div className="kt-subheader   kt-grid__item" id="kt_subheader">
                <div className="kt-container  kt-container--fluid ">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">{t("Paramètres")}</h3>
                        <span className="kt-subheader__separator kt-hidden" />
                        <div className="kt-subheader__breadcrumbs">
                            <a href="#icone" className="kt-subheader__breadcrumbs-home">
                                <i className="flaticon2-shelter" />
                            </a>
                            <span className="kt-subheader__breadcrumbs-separator" />
                            <Link
                                to="/settings/social-medias"
                                className="kt-subheader__breadcrumbs-link"
                                style={{ cursor: "text" }}
                            >
                                {t("Configurations réseaux sociaux ")}
                            </Link>
                        </div>
                        <div className="kt-subheader__breadcrumbs">
                            <span className="kt-subheader__breadcrumbs-separator" />
                            <a
                                href="#button"
                                onClick={(e) => e.preventDefault()}
                                className="kt-subheader__breadcrumbs-link"
                                style={{ cursor: "text" }}
                            >
                                {t("Nouvelle configuration ")}
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
                <div className="kt-portlet">
                    <HeaderTablePage
                        addPermission=""
                        title={t("Ajouter une configuration des réseaux sociaux")}
                    />

                    <div>

                        <div className="kt-portlet__body">


                            <InstitutionSelector
                                onChangeInstitution={onChangeInstitution}
                                institutionData={institutionData}
                                institution={institution}
                                error={error}
                                userPermissions={props.userPermissions}
                                t={t}
                            />
                            {
                                institution ? (
                                    <div className='col-lg-12 col-md-12 col-sm-12'>
                                        <div className="form-group row">
                                            <div className="col-lg-12 col-md-12 col-sm-12">
                                                <div className="kt-separator kt-separator--dashed"></div>
                                            </div>
                                        </div>

                                        <FacebookConfigAddForm 
                                            fields={fields}
                                            addField={addField}
                                            removeField={removeField}
                                            setFields={setFields}
                                            error={error}
                                        />

                                        <WhatsappConfigAddForm 
                                            fields2={fields2}
                                            addField={addField2}
                                            removeField={removeField2}
                                            setFields2={setFields2}
                                            error={error}
                                        />

                                        <LinkedinConfigAddForm 
                                            fields3={fields3}
                                            addField={addField3}
                                            removeField={removeField3}
                                            setFields3={setFields3}
                                            error={error}
                                        />
                       
                                        <div className='form-group row d-flex justify-content-end'>
                                            {
                                                fields.length ? 
                                                    <button className='btn btn-primary' disabled={loading} onClick={onSubmit}>
                                                        {loading && (
                                                            <span className="spinner-border spinner-border-sm m-0"></span>
                                                        )}
                                                        {t("Enregistrer")}
                                                    </button>
                                                : null
                                            }
                                        </div>
                                    </div>
                                ) : null
                            }
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        userPermissions: state.user.user.permissions,
        plan: state.plan.plan,
    };
}

export default connect(mapStateToProps)(SocialMediaConfigAddForm)